import {createAction, props} from '@ngrx/store';
import { Auth } from '@core/models/auth.model';

export const login = createAction('[Login Page] User Login', props<Auth>());
export const register = createAction('[Login Page] User Signup');
export const logout = createAction('[Top Menu] Logout');
